// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// Create backdrop element
const backdrop = document.createElement('div');
backdrop.className = 'sidebar-backdrop';
document.body.appendChild(backdrop);

// Get the elements
const mobileNavigation = document.querySelector('.mobile-navigation');
const mobileNavigationToggleButtons = document.querySelectorAll(
    '[data-toggle="mobile-navigation"]'
);
const enquireSidebar = document.querySelector('.enquire-sidebar');

function updateMenuOffsets() {
    const menuItems = document.querySelectorAll('.menu-item-has-children');

    menuItems.forEach((item) => {
        const offset = item.offsetLeft - 24;
        item.style.setProperty('--menu-item-offset', `${offset}px`);
    });
}

function headerHeight() {
    const header = document.querySelector('.banner');
    const headerHeight = header.offsetHeight;
    document.body.style.setProperty('--header-height', `${headerHeight}px`);
}

// Sticky header functionality
let lastScrollTop = 0;
const scrollThreshold = 100; // Pixels to scroll before hiding header

function handleStickyHeader() {
    const header = document.querySelector('.banner');
    const currentScrollTop = window.scrollY;

    // Add sticky class when scrolling starts
    if (currentScrollTop > 0) {
        header.classList.add('is-sticky');
    } else {
        header.classList.remove('is-sticky');
    }

    // Hide header when scrolling down past threshold
    if (
        currentScrollTop > scrollThreshold &&
        currentScrollTop > lastScrollTop
    ) {
        header.classList.add('is-hidden');
    }
    // Show header when scrolling up
    else if (currentScrollTop < lastScrollTop) {
        header.classList.remove('is-hidden');
    }

    lastScrollTop = currentScrollTop;
}

// Sidebar functionality
function toggleEnquireSidebar(show = true) {
    if (!enquireSidebar) return;

    if (show) {
        enquireSidebar.classList.add('is-active');
        backdrop.classList.add('is-active');
        // Store current scroll position
        document.body.dataset.scrollY = window.scrollY;
        // Add event listeners to prevent scroll
        document.addEventListener('wheel', preventScroll, { passive: false });
        document.addEventListener('touchmove', preventScroll, {
            passive: false,
        });
    } else {
        enquireSidebar.classList.remove('is-active');
        backdrop.classList.remove('is-active');
        // Remove event listeners
        document.removeEventListener('wheel', preventScroll);
        document.removeEventListener('touchmove', preventScroll);
        // Restore scroll position
        window.scrollTo(0, parseInt(document.body.dataset.scrollY || '0'));
        history.replaceState({}, '', window.location.pathname);
    }
}

function togglemobileNavigation(show = true) {
    if (!mobileNavigation) return;

    if (show) {
        mobileNavigation.classList.add('is-active');
        mobileNavigationToggleButtons.forEach((button) => {
            button.classList.add('is-active');
        });
        // Store current scroll position
        document.body.dataset.scrollY = window.scrollY;
        // Add event listeners to prevent scroll
        document.addEventListener('wheel', preventScroll, { passive: false });
        document.addEventListener('touchmove', preventScroll, {
            passive: false,
        });
    } else {
        mobileNavigation.classList.remove('is-active');
        mobileNavigationToggleButtons.forEach((button) => {
            button.classList.remove('is-active');
        });
        // Remove event listeners
        document.removeEventListener('wheel', preventScroll);
        document.removeEventListener('touchmove', preventScroll);
        // Restore scroll position
        window.scrollTo(0, parseInt(document.body.dataset.scrollY || '0'));
    }
}

// Prevent scroll function
function preventScroll(e) {
    if (!enquireSidebar) return;

    // Allow scrolling within the sidebar
    if (enquireSidebar.contains(e.target)) {
        return;
    }

    e.preventDefault();
}

// Function to check URL and toggle sidebar accordingly
function checkURLForEnquire() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('enquire') || window.location.hash === '#enquire') {
        toggleEnquireSidebar(true);
    }
}

// Function to handle HubSpot form submissions
function setupHubSpotFormListener() {
    // Check if HubSpot forms exist on the page
    if (typeof window.hbspt === 'undefined') return;

    // Listen for HubSpot form submission events
    window.addEventListener('message', function(event) {
        // Make sure the message is from HubSpot
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
            // Fade out all elements with pre-submit class
            $('.pre-submit').fadeOut(300, function() {
                // Once fade out is complete, fade in the post-submit elements
                $('.post-submit').fadeIn(300);
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuOffsets();
    headerHeight();

    // Initialize sticky header
    handleStickyHeader();

    // Setup HubSpot form listener
    setupHubSpotFormListener();

    // Toggle buttons
    const toggleButtons = document.querySelectorAll(
        '[data-toggle="enquire-sidebar"]'
    );
    toggleButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const isActive = enquireSidebar.classList.contains('is-active');
            toggleEnquireSidebar(!isActive);
        });
    });

    // Mobile navigation toggle buttons
    mobileNavigationToggleButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const isActive = mobileNavigation.classList.contains('is-active');
            togglemobileNavigation(!isActive);
        });
    });

    // Mobile navigation submenu toggle buttons
    const mobileNavigationSubmenuToggleButtons = document.querySelectorAll(
        '[data-mobile-navigation-submenu-toggle]'
    );
    mobileNavigationSubmenuToggleButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const isActive = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !isActive);
            const submenu = button.nextElementSibling;
            if (submenu) {
                submenu.classList.toggle('is-active');
            }
        });
    });

    // Mobile navigation submenu back buttons
    const mobileNavigationSubmenuBackButtons = document.querySelectorAll(
        '[data-mobile-navigation-submenu-back]'
    );
    mobileNavigationSubmenuBackButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const submenu = button.parentElement.parentElement;
            if (submenu) {
                submenu.classList.remove('is-active');
            }
        });
    });

    // Enquire sidebar close buttons
    const enquireSidebarCloseButtons = document.querySelectorAll(
        '.enquire-sidebar__close'
    );
    if (enquireSidebarCloseButtons.length) {
        enquireSidebarCloseButtons.forEach((button) => {
            button.addEventListener('click', () =>
                toggleEnquireSidebar(false)
            );
        });
    }

    // Check URL parameter on page load
    checkURLForEnquire();
});

// Update the click outside handler to use the backdrop
document.addEventListener('click', (e) => {
    // Fix the conditional logic by properly grouping the conditions
    if (!enquireSidebar || !enquireSidebar.classList.contains('is-active')) {
        return;
    }

    // Check if click is on backdrop
    if (e.target === backdrop) {
        toggleEnquireSidebar(false);
    }
});

// Run on scroll
window.addEventListener('scroll', function () {
    handleStickyHeader();
});

// Run on resize
window.addEventListener('resize', function () {
    updateMenuOffsets();
    headerHeight();

    if (window.innerWidth > 1200) {
        backdrop.classList.remove('is-active');
    } else {
        if (enquireSidebar.classList.contains('is-active')) {
            backdrop.classList.add('is-active');
        } else {
            backdrop.classList.remove('is-active');
        }
    }
});

// Listen for hash changes
window.addEventListener('hashchange', checkURLForEnquire);

// For query parameter changes (which don't trigger hashchange)
// Use a MutationObserver to watch for URL changes
const oldPushState = history.pushState;
history.pushState = function() {
    oldPushState.apply(this, arguments);
    checkURLForEnquire();
};

const oldReplaceState = history.replaceState;
history.replaceState = function() {
    oldReplaceState.apply(this, arguments);
    checkURLForEnquire();
};

// Also check when navigating with browser back/forward buttons
window.addEventListener('popstate', checkURLForEnquire);
